"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const modules_1 = require("@/store/modules");
const vuex_1 = require("vuex");
const vue_property_decorator_1 = require("vue-property-decorator");
const __webpack_public_path__1 = require("@/__webpack_public_path__");
const store_1 = tslib_1.__importDefault(require("@/store"));
const utils_1 = require("@/utils");
const aemEnvironments_1 = require("@/utils/aemEnvironments");
const dialogParameters_1 = require("@/utils/dialogParameters");
const error_vue_1 = tslib_1.__importDefault(require("@/components/error/error.vue"));
const grid_column_vue_1 = tslib_1.__importDefault(require("@/components/grid-column/grid-column.vue"));
const loading_spinner_vue_1 = tslib_1.__importDefault(require("@/components/loading-spinner/loading-spinner.vue"));
const mq_indicator_vue_1 = tslib_1.__importDefault(require("@/components/mq-indicator/mq-indicator.vue"));
require("@/assets/main.scss");
const VehicleTile_vue_1 = tslib_1.__importDefault(require("@/views/VehicleTile.vue"));
const TrackingManager_1 = require("@/utils/TrackingManager");
const mapEnvAsset = (aemEnv) => {
    console.log('aemEnv', aemEnv);
    switch (aemEnv ? aemEnv.toLowerCase() : '') {
        case 'prod':
            return '';
        case 'pprod':
            return 'preprod.';
        case '':
            return '';
        default:
            return `${aemEnv}.`;
    }
};
(0, __webpack_public_path__1.initAssetServer)();
vue_1.default.component('grid-column', grid_column_vue_1.default);
let App = class App extends vue_1.default {
    /**
     * Show error component whenever the app is running in development env
     * and app status is set to error
     */
    get shouldShowError() {
        return this.environment === 'development' && this.appStatus === utils_1.APP_STATUS.ERROR;
    }
    getEnvironment(stage) {
        const ocapiEnv = {
            dev: 'development',
            int: 'development',
            test: 'test',
            pprod: 'test',
        };
        const stageEnv = stage ? ocapiEnv[stage.toLowerCase()] : '';
        return stageEnv || 'production';
    }
    get isLocal() {
        return window.location.hostname === 'localhost';
    }
    isInitialisedByProps() {
        return !!this.initialisationProperties;
    }
    attachIntersectionObserver() {
        const options = {
            threshold: 0.25,
        };
        const applicationElement = this.$refs.application;
        if (window.IntersectionObserver) {
            this.intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        TrackingManager_1.tracking.initialize();
                        this.intersectionObserver.unobserve(applicationElement);
                    }
                });
            }, options);
            this.intersectionObserver.observe(applicationElement);
        }
        else {
            TrackingManager_1.tracking.initialize();
        }
    }
    getInitialisationData() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.isInitialisedByProps()) {
                const { market, language, environment, applicationType, applicationBrand = utils_1.APP_BRAND.MERCEDES_BENZ_CARS, typeId, modelSeries, subBrand, subBrands, engineConcept, customConfiguration, defaultFinancingProduct, defaultCustomerType, } = this.initialisationProperties;
                return {
                    language,
                    market,
                    locale: `${language}_${market}`,
                    localeFormat: `${language}-${market}`,
                    appType: applicationType,
                    applicationBrand,
                    defaultFinancingProduct,
                    defaultCustomerType,
                    customConfiguration,
                    environment,
                    vehicle: {
                        typeId,
                        modelSeries,
                        subBrand,
                        subBrands,
                        engineConcept,
                    },
                };
            }
            try {
                let environmentData = {};
                if (this.isLocal) {
                    const file = yield fetch(`aem-environment-data.json`);
                    environmentData = yield file.json();
                }
                else {
                    environmentData = yield (0, aemEnvironments_1.getAemEnvironmentVariables)();
                }
                console.log('environmentData', environmentData, this.isLocal);
                let aemComponentData = {};
                if (this.isLocal) {
                    const file = yield fetch(`aem-component-data.json`);
                    aemComponentData = yield file.json();
                }
                else {
                    aemComponentData = yield (0, dialogParameters_1.getAemComponentData)(this.componentId);
                }
                console.log('aemComponentData', aemComponentData, this.isLocal);
                const dialogData = aemComponentData.payload;
                const hasMissingAemParameter = !Object.keys(environmentData).length || !Object.keys(dialogData).length;
                if (hasMissingAemParameter) {
                    console.log('fcis_environmentData::', environmentData);
                    console.log('fcis_aemComponentData::', aemComponentData);
                    throw new Error();
                }
                const { country, language, stage, vehicleData } = environmentData;
                const { applicationType, applicationBrand = utils_1.APP_BRAND.MERCEDES_BENZ_CARS, typeId, defaultFinancingProduct, defaultCustomerType, } = dialogData;
                return {
                    language,
                    market: country,
                    locale: `${language}_${country}`,
                    localeFormat: `${language}-${country}`,
                    appType: applicationType,
                    applicationBrand,
                    defaultFinancingProduct,
                    defaultCustomerType,
                    environment: this.getEnvironment(stage),
                    vehicle: {
                        typeId,
                        modelSeries: vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.modelSeries,
                        subBrand: vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.subBrand,
                        subBrands: vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.subBrands,
                        engineConcept: vehicleData === null || vehicleData === void 0 ? void 0 : vehicleData.engineConcept,
                    },
                };
            }
            catch (e) {
                this.setAppStatus(utils_1.APP_STATUS.ERROR, { message: 'MARKET_UNAVAILABLE' });
                return null;
            }
        });
    }
    onPropsChange() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.initialiseApp();
        });
    }
    onDisableFullscreenViewsChange() {
        if (this.disableFullscreenViews) {
            this.disableVehicleSelectorFullscreen(this.disableFullscreenViews);
        }
    }
    initialiseApp() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const initialisationData = yield this.getInitialisationData();
                if (initialisationData) {
                    this.initialiseApplication(initialisationData);
                }
            }
            catch (e) {
                this.setAppStatus(utils_1.APP_STATUS.ERROR, { message: 'MARKET_UNAVAILABLE' });
            }
        });
    }
    mounted() {
        var _a;
        const { VUE_APP_AEM_FORMS_ENDPOINT = '' } = process.env;
        const aemEnv = (((_a = window.aemNamespace) === null || _a === void 0 ? void 0 : _a.pageEnvironmentVariables) || {}).stage;
        if (VUE_APP_AEM_FORMS_ENDPOINT) {
            (0, utils_1.appendScript)(VUE_APP_AEM_FORMS_ENDPOINT.replace('{prefix}', mapEnvAsset(aemEnv)));
        }
        document.body.dispatchEvent(new CustomEvent(utils_1.APPLICATION_READY_EVENT_ID));
        window.sessionStorage.removeItem('swsp:FCIS_DATA');
        this.attachIntersectionObserver();
        this.initialiseApp();
    }
};
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)()
], App.prototype, "initialisationProperties", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)()
], App.prototype, "disableFullscreenViews", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'fcis-owdc', required: false, type: String })
], App.prototype, "componentId", void 0);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Watch)('initialisationProperties')
], App.prototype, "onPropsChange", null);
tslib_1.__decorate([
    (0, vue_property_decorator_1.Watch)('disableFullscreenViews', { immediate: true })
], App.prototype, "onDisableFullscreenViewsChange", null);
App = tslib_1.__decorate([
    (0, vue_property_decorator_1.Component)({
        name: 'App',
        store: store_1.default,
        components: { VehicleTile: VehicleTile_vue_1.default, ErrorBase: error_vue_1.default, LoadingSpinner: loading_spinner_vue_1.default, MqIndicator: mq_indicator_vue_1.default },
        computed: Object.assign({}, (0, vuex_1.mapGetters)(['appStatus', 'environment', 'appErrorCode'])),
        methods: Object.assign(Object.assign({}, (0, vuex_1.mapActions)(['initialiseApplication', 'setAppStatus'])), (0, vuex_1.mapActions)(modules_1.MODULES.VEHICLE_SELECTOR, { disableVehicleSelectorFullscreen: 'disableFullscreen' })),
        data: () => {
            return {
                APPLICATION_ID: utils_1.APPLICATION_ID,
                APP_STATUS: utils_1.APP_STATUS,
                IS_LOCAL: process.env.VUE_APP_VMDS_DEV,
            };
        },
    })
], App);
exports.default = App;
